import { render } from "./GetQuestions.html?vue&type=template&id=dec2ee7a&external"
import script from "./GetQuestions.js?vue&type=script&lang=js&external"
export * from "./GetQuestions.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__